import React from 'react';
import { motion } from 'framer-motion';

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 30, className = '' }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: '-70px' }}
    transition={{ duration: 0.75, delay, ease: EASE }}
  >{children}</motion.div>
);

export const MaskedLines = ({ lines, testId }) => (
  <h1 data-testid={testId}>
    {lines.map((line, i) => (
      <span className="mask-line" key={i}>
        <motion.span
          initial={{ y: '112%' }}
          animate={{ y: 0 }}
          transition={{ duration: 0.95, delay: 0.15 + i * 0.13, ease: EASE }}
        >{line}</motion.span>
      </span>
    ))}
  </h1>
);

export const Marquee = ({ items, testId = 'editorial-marquee' }) => (
  <div className="marquee" data-testid={testId} aria-hidden="true">
    <div className="marquee-track">
      {[...items, ...items].map((item, i) => <span key={i}>{item}<i /></span>)}
    </div>
  </div>
);
